import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import NotificationsIcon from '@material-ui/icons/Notifications';
import Badge from '@material-ui/core/Badge';

import * as alertsSelectors from 'data/alerts/alertsSelectors';
import { getAlerts } from 'data/alerts/alertsActions';
import useFetchOnce from 'hooks/useFetchOnce';
import QPopper from 'components/QPopper';

export default function NotificationsNavIcon() {

  useFetchOnce(getAlerts, alertsSelectors);
  const [popperAnchorEl, setPopperAnchorEl] = useState();
  const [showPopper, setShowPopper] = useState(false);
  const alertsUnread = useSelector(alertsSelectors.getAlertsUnread);
  const alerts = useSelector(alertsSelectors.getAlerts);

  return (
    <>
      <Badge
        max={99}
        badgeContent={alertsUnread.size}
        color="primary"
      >
        <NotificationsIcon
          ref={(ref) => setPopperAnchorEl(ref)}
          onClick={() => setShowPopper(!showPopper)}
        />
      </Badge>

      <QPopper
        anchorEl={popperAnchorEl}
        open={Boolean(showPopper)}
        placement="right"
        onClickAway={() => setShowPopper(false)}
      >
        {alerts.valueSeq().map((alert) => (
          <div key={alert.id}>
            <img src={alert.icon} alt="" width={24} height={24}/>
            {alert.group}:{alert.type}:{alert.title}
            <div>
              {alert.message}
            </div>
          </div>
        ))}
      </QPopper>
    </>
  );
}
